import styles from './RegistrationBlock.module.scss';
import { Title } from '../../../../components/Title/Title';
import { Subtitle } from '../../../../components/Subtitle/Subtitle';
import { Image } from '../../../../components/Image/Image';
import classNames from 'classnames';
import { RegistrationForm } from './RegistrationForm';
import { useRegistrationSection } from '../../../../providers/RegistrationSectionProvider/useRegistrationData';
export const RegistrationBlock = ()=>{
  const {content,nextSlug } = useRegistrationSection();
  const { title, subtitle, image } = content;

  
  return (
    <>
    <div className={styles.section}>
      {image && <Image
        src={image}
        className={styles.image}
      />}
      <div className={styles.content}>
        {title && <Title className={styles.title}>{title}</Title>}
        {subtitle && <Subtitle className={classNames(styles.subtitle, 'registration__subtitle')} dangerouslySetInnerHTML={{ __html:subtitle }}/>}
      </div>
      <RegistrationForm content={content} nextSlug={nextSlug} />
    </div>
  </>
  )
}